import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DragDropModule } from '@angular/cdk/drag-drop';

import { SnIconModule } from '@lib/ui/icon';
import { SnActionsModule } from '@lib/ui/actions';

import { DragBarComponent } from './drag-bar/drag-bar.component';

@NgModule({
  imports: [CommonModule, DragDropModule, SnIconModule, SnActionsModule],
  exports: [DragBarComponent],
  declarations: [DragBarComponent],
})
export class FsDragBarModule {}
